import { useConfirmSalaryModal } from './useConfirmSalaryModal';

export { useConfirmSalaryModal };
